import { createContext, useContext, useEffect, useRef } from "react";
import { BASE_URL_API } from "../Constants";

const RefreshContext = createContext(null);

export function RefreshProvider({ userId, children }) {

    // subscribers.current = {
    //    orders: Set(callbacks),
    //    meetings: Set(callbacks),
    //    users: Set(callbacks)
    // }
    const subscribers = useRef({});

    const subscribe = (trigger, callback) => {
        if (!subscribers.current[trigger]) {
            subscribers.current[trigger] = new Set();
        }

        subscribers.current[trigger].add(callback);
        console.log("🟢 Subscribed to:", trigger);

        return () => {
            if (subscribers.current[trigger]) {
                subscribers.current[trigger].delete(callback);
                console.log("🔴 Unsubscribed from:", trigger);

                if (subscribers.current[trigger].size === 0) {
                    delete subscribers.current[trigger];
                }
            }
        };
    };

    useEffect(() => {
        if (!userId) return;

        const eventSource = new EventSource(
            `${BASE_URL_API}/refresh/stream?user_id=${userId}`,
            { withCredentials: true }
        );

        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log("event", data)


            subscribers.current[data.trigger]?.forEach(cb => cb(data));
        };

        return () => eventSource.close();

    }, [userId]);

    return (
        <RefreshContext.Provider value={{ subscribe }}>
            {children}
        </RefreshContext.Provider>
    );
}

export const useRefresh = () => useContext(RefreshContext);